import { Box, FormLabel, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

interface Props {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  floatLabelCard: {
    border: `1px solid ${theme.palette.gray}`,
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    padding: '8px 10px',
    backgroundColor: theme.palette.background.default,
    marginTop: 4,
  },
  label: {
    backgroundColor: theme.palette.background.default,
    position: 'absolute',
    left: 5,
    top: -10,
    fontSize: '0.75rem',
    padding: '0px 5px',
    height: 11,
  },
}));

const FloatLabelCard: FC<Props> = ({ label, children, className }) => {
  const styles = useStyles();
  const compClass = classNames(styles.floatLabelCard, className);
  const hasLabel = !!label;
  return (
    <Box className={compClass}>
      {hasLabel && (
        <FormLabel className={`${styles.label} MuiInputLabel-sizeSmall`}>{label}</FormLabel>
      )}
      {children}
    </Box>
  );
};

export default FloatLabelCard;
